import React, { useState } from "react"
import {
    Box,
    Modal,
    Typography,
    TextField,
    Button,
} from "@mui/material"

export default function CreateRosterModal({ open, onClose, onCreate }) {
    const [rosterName, setRosterName] = useState("")
    const [loading, setLoading] = useState(false)

    const handleChange = (e) => {
        setRosterName(e.target.value)
    }

    const handleCreate = async () => {
        if (!rosterName.trim()) {
            return
        }
        setLoading(true)
        try {
            await onCreate(rosterName.trim())
            setRosterName("")
        } catch (error) {
            // Error handling is done in parent
        } finally {
            setLoading(false)
        }
    }

    const handleClose = () => {
        if (!loading) {
            setRosterName("")
            onClose()
        }
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    border: "1px solid #E4E7EC",
                    width: "460px",
                    p: 4,
                    boxShadow: "0px 8px 24px rgba(0,0,0,0.1)",
                }}
            >
                {/* Title */}
                <Typography
                    sx={{
                        fontWeight: 600,
                        fontSize: "20px",
                        color: "#101828",
                        mb: 3,
                    }}
                >
                    Create Project Roster
                </Typography>

                {/* Form */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    <TextField
                        fullWidth
                        label="Roster Name"
                        name="rosterName"
                        value={rosterName}
                        onChange={handleChange}
                        size="small"
                        required
                        placeholder="e.g., Weekly roster"
                        disabled={loading}
                    />
                </Box>

                {/* Action Buttons */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1.5,
                        mt: 4,
                    }}
                >
                    <Button
                        variant="outlined"
                        onClick={handleClose}
                        disabled={loading}
                        sx={{
                            textTransform: "none",
                            borderColor: "#E4E7EC",
                            color: "#344054",
                            "&:hover": { borderColor: "#D0D5DD" },
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleCreate}
                        disabled={loading || !rosterName.trim()}
                        sx={{
                            backgroundColor: "#4D6BF6",
                            textTransform: "none",
                            fontWeight: 500,
                            "&:hover": { backgroundColor: "#3D5BD6" },
                            "&:disabled": { backgroundColor: "#E4E7EC", color: "#667085" },
                        }}
                    >
                        {loading ? "Creating..." : "Create Roster"}
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
}

